import { render } from "./eb-user-menu.vue?vue&type=template&id=f8099aba"
import script from "./eb-user-menu.vue?vue&type=script&lang=ts"
export * from "./eb-user-menu.vue?vue&type=script&lang=ts"
script.render = render

export default script